import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

@Injectable()
export class SessaoExpiradaRouterService
{
    constructor(private router: Router) {}
}
